
export default function Company() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            運営会社
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-4"></div>
        </div>
        
        <div className="bg-gradient-to-br from-blue-50 to-white p-10 rounded-2xl border-2 border-blue-100">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              株式会社インフォレスタ
            </h3>
            <p className="text-gray-700 leading-relaxed">
              医学・製薬・研究領域に特化した文献サービスの専門企業として、前身の「株式会社伸樹社」を含め、私たちは40年以上にわたり、全国の医療機関・大学・製薬企業の文献業務を支援してきました。
            </p>
          </div>
          
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-blue-600 rounded-lg flex-shrink-0">
                <i className="ri-award-line text-xl text-white"></i>
              </div>
              <div>
                <p className="text-gray-700 leading-relaxed">
                  医療・製薬・研究領域に特化して<strong>40年以上</strong>
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-blue-600 rounded-lg flex-shrink-0">
                <i className="ri-file-text-line text-xl text-white"></i>
              </div>
              <div>
                <p className="text-gray-700 leading-relaxed">
                  年間<strong>48,000件を超える文献サービス利用実績</strong>(2024年度)
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-blue-600 rounded-lg flex-shrink-0">
                <i className="ri-team-line text-xl text-white"></i>
              </div>
              <div>
                <p className="text-gray-700 leading-relaxed">
                  大学病院・研究機関・製薬企業・広告代理店など幅広い法人が利用
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-blue-600 rounded-lg flex-shrink-0">
                <i className="ri-file-shield-line text-xl text-white"></i>
              </div>
              <div>
                <p className="text-gray-700 leading-relaxed">
                  有料誌のPDF入手、OA判定、転載許諾申請に精通
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-blue-600 rounded-lg flex-shrink-0">
                <i className="ri-shield-check-line text-xl text-white"></i>
              </div>
              <div>
                <p className="text-gray-700 leading-relaxed">
                  著作権ポリシー遵守で安心の業務フロー
                </p>
              </div>
            </div>
          </div>
          
          <div className="mt-8 pt-8 border-t border-blue-200">
            <p className="text-gray-700 leading-relaxed text-center">
              文献検索からPDF入手、転載許諾取得、請求書1本化まで、製薬企業の業務を確実・迅速にサポートいたします。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
